import { useTranslation } from 'react-i18next';
import { requestForQuoteProductName } from '~/utils/requestForQuoteProductName';
import { Link } from 'react-router';
import { useGetRequestForQuotes } from '~/api';
import { formatRelativeTime } from '~/utils';
import { DashboardListColumn } from './DashboardColumn';

export function RequestForQuotesColumn() {
  const { t } = useTranslation('dashboard');
  const { requestForQuotes, isLoading, isError } = useGetRequestForQuotes();

  return (
    <DashboardListColumn
      title={t('dashboard.request_for_quotes.title')}
      subtitle={t('dashboard.request_for_quotes.subtitle')}
      items={requestForQuotes}
      isLoading={isLoading}
      isError={isError}
      emptyText={t('dashboard.request_for_quotes.empty')}
      errorText={t('dashboard.request_for_quotes.error')}
      getKey={(requestForQuote) => requestForQuote.id}
      sortBy={(a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      }
      renderRow={(requestForQuote) => (
        <>
          <div className="flex items-center justify-between gap-2">
            <Link
              to={`/rfq/view/${requestForQuote.id}`}
              className="text-sm font-medium text-prim hover:text-prim-hover"
            >
              {requestForQuoteProductName(requestForQuote) ??
                t('dashboard.multiple_products')}
            </Link>
            <span className="text-xs font-medium text-neut-sec shrink-0">
              {t(
                `dashboard.request_for_quotes.status.${requestForQuote.status}`
              )}
            </span>
          </div>
          <div className="flex items-center justify-between gap-2">
            <p className="text-xs font-medium text-neut-sec">
              {t('dashboard.request_for_quotes.item_count', {
                count: requestForQuote.items.length,
              })}
            </p>
            <p className="text-xs font-medium text-neut-sec shrink-0">
              {formatRelativeTime(requestForQuote.createdAt, t)}
            </p>
          </div>
        </>
      )}
    />
  );
}
